import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto text-center" data-id="element-25">
        <div className="inline-flex items-center justify-center p-4 bg-emerald-100 rounded-full mb-6" data-id="element-26">
          <ShieldCheck className="h-10 w-10 text-emerald-600" data-id="element-27" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-28">
          Garantía de Hierro de 7 Días
        </h2>
        <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-29">
          Estoy tan seguro de que este protocolo cambiará su vida que asumo todo
          el riesgo. Si en 7 días no siente más energía y ve una mejora en sus
          mediciones, <strong data-id="element-30">le devuelvo cada peso</strong>. Sin preguntas, sin
          letra chica.
        </p>
        <div className="p-4 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 inline-block" data-id="element-31">
          <p className="text-sm text-gray-500 font-medium" data-id="element-32">
            Su inversión está 100% protegida. No tiene nada que perder, excepto
            esos números altos.
          </p>
        </div>
      </div>
    </section>;
}